export default "__VITE_ASSET__BEV5o7p$__"